import { render } from "./MainLayout.vue?vue&type=template&id=b702570e&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=b702570e&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=b702570e&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b702570e"]])

export default __exports__